import { createFileRoute } from '@tanstack/react-router';
import { organizationQueries } from '@/features/organizations/queries';
import { OrganizationsPage } from '@/features/organizations/pages/OrganizationsPage';
import { OrganizationsPageSkeleton } from '@/common/components/loading-skeleton/OrganizationsPageSkeleton';

export const Route = createFileRoute('/_authenticated/organizations/')({
  component: OrganizationsPage,
  pendingComponent: OrganizationsPageSkeleton,
  loader: async ({ context }) => {
    await context.queryClient.ensureQueryData(organizationQueries.list());
  },
});
